module.exports = __webpack_public_path__ + "9e59bd795e3d4b50db91c027fcaf44ca.pdf";